<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="关键字" class="kw">
          <el-input
            placeholder="请输入"
            v-model="searchData.keywordValue"
            class="input-with-select"
            size="small"
          >
            <el-select
              v-model="searchData.keywordName"
              slot="prepend"
              placeholder="请选择"
              size="small"
              style="width: 100px"
            >
              <el-option
                v-for="item in searchTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="资方归属">
          <select-capital-org
            style="width: 180px"
            v-model="searchData.capitalOrgCode"
          />
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            style="width: 340px"
            v-model="orderCreateDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="送审时间">
          <el-date-picker
              style="width: 340px"
              v-model="submitDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="审核时间">
          <el-date-picker
            style="width: 340px"
            v-model="reviewDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select
            style="width: 180px"
            v-model="orderStatusList"
            placeholder="请选择"
            size="small"
            multiple
            clearable
          >
            <el-option
              v-for="item in orderStatusOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备状态">
          <el-select
            style="width: 180px"
            v-model="searchData.deviceStatus"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in dict_device_status"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
              style="width: 150px"
              v-model="searchData.reviewStatus"
              placeholder="请选择"
              size="small"
              clearable
          >
            <el-option
                v-for="item in reviewStatusOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分账进度">
          <el-select
            style="width: 150px"
            v-model="searchData.royaltyStatus"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in royaltyStatusOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分账类型">
          <el-select
            style="width: 150px"
            v-model="searchData.royaltyType"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in royaltyTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" " label-width="50px">
          <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">查询</el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="head-btn">
      <div></div>
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.capital_org_zst_order_list_export)"
        type="primary"
        icon="el-icon-download"
        size="small"
        @click="handleExport"
      >导出</el-button>
    </div>

    <el-table :data="list" style="width: 100%">
      <el-table-column label="用户信息" min-width="180">
        <template slot-scope="{ row }">
          <div>
            <div>姓名：{{ row.memberName }}</div>
            <div>手机号：{{ row.memberMobile }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="订单信息" min-width="280">
        <template slot-scope="{ row }">
          <div>
            <div>订单单号：{{ row.orderNo }}</div>
            <div>交易组件单号：{{ row.alipayOrderId }}</div>
            <div>下单时间：{{ row.orderCreateTime }}</div>
            <div>订单状态：{{ row.orderStatusName }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商品信息" min-width="240">
        <template slot-scope="{ row }">
          <div>
            <div>
              {{ row.goodsTitle || "-" }}
              <el-tag
                v-if="row.goodsPurity"
                :type="row.goodsPurity === 'fresh' ? 'primary' : 'warning'"
                size="mini"
                style="margin-left: 2px"
              >{{ row.goodsPurityName }}</el-tag>
            </div>
            <div>设备状态：{{ row.deviceStatusName || "-" }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="资方归属" min-width="240">
        <template slot-scope="{ row }">
          <div>
            <div>名称：{{ row.investName }}</div>
            <div>送审时间：{{ row.submitTime }}</div>
            <div>审核时间：{{ row.reviewTime }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="reviewStatusName" label="审核状态" min-width="100"></el-table-column>
      <el-table-column prop="investPrice" label="融资金额" min-width="100"></el-table-column>
      <el-table-column label="租金分账信息" min-width="180">
        <template slot-scope="{ row }">
          <div>
            <div>计划分账期数：{{ row.planRentRoyaltyNum }}</div>
            <div>已分账期数：{{ row.execRentRoyaltyNum }}</div>
            <div>计划分账金额：{{ row.planRentRoyaltyPrice }}</div>
            <div>租金已分账金额：{{ row.execRentRoyaltyPrice }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="execOtherRoyaltyPrice" label="买断/取消分账" min-width="110">
        <template slot-scope="{ row }">
          {{ row.execOtherRoyaltyPrice || '–' }}
        </template>
      </el-table-column>
      <el-table-column prop="execTotalRoyaltyPrice" label="已分账总金额" min-width="110"></el-table-column>
      <el-table-column prop="investProfitPrice" label="服务费" min-width="80"></el-table-column>
      <el-table-column prop="investRepayPrice" label="资方差额回款" min-width="110"></el-table-column>
      <el-table-column label="分账类型" min-width="110">
        <template slot-scope="{ row }">
          {{ getZstRoyaltyTypeText(row.royaltyType) }}
        </template>
      </el-table-column>
      <el-table-column label="分账进度" min-width="100">
        <template slot-scope="{ row }">
          {{ getZstRoyaltyStatusText(row.royaltyStatus) }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="160">
        <template slot-scope="{ row }">
          <el-link
            type="primary"
            :underline="false"
            @click="handleDetail(row)"
          >分账明细</el-link>

          <el-link
              v-if="row.reviewStatus == 1 && row.royaltyStatus == 1 && (row.orderStatus == 6 || row.orderStatus == 7)"
              v-checkbtn="isShowBtn(AUTH_BTN.capital_org_zst_order_list_buy_back)"
              style="margin-left: 5px"
              type="primary"
              :underline="false"
              @click="handleBuyback(row)"
          >提前回购</el-link>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      :total="total"
      :page.sync="searchData.page"
      :limit.sync="searchData.pageSize"
      @pagination="getList"
    />

    <!-- 分账明细弹窗 -->
    <RoyaltyDetail
      :visible.sync="royaltyDetailVisible"
      :order-id="currentOrderId"
    />

    <div style="height: 100px"></div>
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { getZstOrderListAPI, exportZstOrderAPI, buybackZstOrderAPI } from "./api";
import RoyaltyDetail from "./components/royalty-detail.vue";
import SelectCapitalOrg from "@/views/components/select-capital-org.vue";
import { dict_device_status } from "@/enum/dict/index.js";
import {
  ZstRoyaltyStatusList,
  getZstRoyaltyStatusText,
  ZstRoyaltyTypeList,
  getZstRoyaltyTypeText,
} from "@/enum/dict/zst";

const searchTypeOptions = [
  { name: "用户姓名", value: "memberName" },
  { name: "订单号", value: "orderNo" },
  { name: "交易组件单号", value: "alipayOrderId" },
];

const orderStatusOptions = [
  { name: "租赁中", value: "6" },
  { name: "逾期中", value: "7" },
  { name: "待买断", value: "8" },
  { name: "已完成", value: "91" },
  { name: "已取消", value: "92" },
];

const reviewStatusOptions = [
  { name: "待审核", value: 0 },
  { name: "审核通过", value: 1 },
  { name: "审核拒绝", value: 2 },
];

export default {
  name: "ZstOrderList",
  mixins: [authBtnMixin],
  components: { RoyaltyDetail, SelectCapitalOrg },

  data() {
    return {
      total: 0,
      list: [],
      searchData: {
        page: 1,
        pageSize: 10,
        keywordName: "memberName",
        keywordValue: "",
        reviewStatus: "",
        royaltyType: "",
        royaltyStatus: "",
        capitalOrgCode: "",
        deviceStatus: "",
      },
      orderCreateDateRange: [],
      submitDateRange: [],
      reviewDateRange: [],
      orderStatusList: [],
      searchTypeOptions,
      orderStatusOptions,
      reviewStatusOptions,
      dict_device_status,
      royaltyStatusOptions: ZstRoyaltyStatusList,
      royaltyTypeOptions: ZstRoyaltyTypeList,
      royaltyDetailVisible: false,
      currentOrderId: null,
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    getZstRoyaltyTypeText,
    getZstRoyaltyStatusText,

    buildParams() {
      const params = {
        page: this.searchData.page,
        pageSize: this.searchData.pageSize,
        reviewStatus: this.searchData.reviewStatus,
        royaltyType: this.searchData.royaltyType,
        royaltyStatus: this.searchData.royaltyStatus,
        capitalOrgCode: this.searchData.capitalOrgCode,
        deviceStatus: this.searchData.deviceStatus,
      };
      // 关键字搜索
      if (this.searchData.keywordName && this.searchData.keywordValue) {
        params[this.searchData.keywordName] = this.searchData.keywordValue;
      }
      // 下单时间
      if (this.orderCreateDateRange && this.orderCreateDateRange.length > 0) {
        params.leftOrderCreateDate = this.orderCreateDateRange[0];
        params.rightOrderCreateDate = this.orderCreateDateRange[1];
      }
      // 送审时间
      if (this.submitDateRange && this.submitDateRange.length > 0) {
        params.leftSubmitDate = this.submitDateRange[0];
        params.rightSubmitDate = this.submitDateRange[1];
      }
      // 审核时间
      if (this.reviewDateRange && this.reviewDateRange.length > 0) {
        params.leftReviewDate = this.reviewDateRange[0];
        params.rightReviewDate = this.reviewDateRange[1];
      }
      // 订单状态（多选）
      if (this.orderStatusList && this.orderStatusList.length > 0) {
        params.orderStatusList = this.orderStatusList.join(",");
      }
      return params;
    },

    async getList() {
      const res = await getZstOrderListAPI(this.buildParams());
      this.list = res.list || [];
      this.total = res.total || 0;
    },

    reset() {
      this.orderCreateDateRange = [];
      this.submitDateRange = [];
      this.reviewDateRange = [];
      this.orderStatusList = [];
      this.searchData = {
        page: 1,
        pageSize: this.searchData.pageSize,
        keywordName: "memberName",
        keywordValue: "",
        royaltyType: "",
        royaltyStatus: "",
        capitalOrgCode: "",
        deviceStatus: "",
      };
      this.getList();
    },

    handleExport() {
      exportZstOrderAPI(this.buildParams());
    },

    handleDetail(row) {
      this.currentOrderId = row.id;
      this.royaltyDetailVisible = true;
    },

    handleBuyback(row) {
      this.$confirm("确认要提前回购该笔订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          buybackZstOrderAPI({id: row.id}).then(() => {
            this.$message.success("操作成功");
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .el-divider--horizontal {
    margin: 10px 0 20px;
  }
  .head-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .el-form {
    .el-form-item {
      margin-right: 25px;
      margin-bottom: 10px;
    }
  }
}

.header-search {
    margin-bottom: 20px;
    .el-form {
      .el-form-item {
        margin-right: 15px;
        margin-bottom: 10px;
        .el-input,
        .el-select {
          width: 180px;
        }
        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }
          .el-range-input {
            width: 35%;
          }
        }
      }
      .kw {
        .el-select .el-input {
          width: 118px;
        }
        .el-select {
          width: 120px;
        }
        .input-with-select {
          vertical-align: middle;
          width: 320px;
        }
        .input-with-select .el-input-group__prepend {
          background-color: #fff;
        }
      }
      .store {
        width: 350px;
        .el-input__inner {
          width: 230px;
        }
      }
    }
  }
</style>
